import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Nav from "react-bootstrap/Nav";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import StudentGroupDropDown from "../Shared/StudentGroupDropDown";
import StudentStatusDropDown from "../Shared/StudentStatusDropDown";
import ConcessionDropDown from "../Shared/ConcessionDropDown";
import BusrouteDropDown from "../Shared/BusrouteDropDown";
import StudentMenu from "./StudentMenu";
import { toast, ToastContainer } from "react-toastify";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import Form from "react-bootstrap/Form";
import { scrollToTop } from "../Shared/ScrollOnTop";

function StudentNotifications() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const fullName = localStorage.getItem("FullName") || "";
  const groupName = localStorage.getItem("Group_Name") || "";

  const [activeTab, setActiveTab] = useState("send");
  const [showFilters, setShowFilters] = useState(true);

  const [loadingList, setLoadingList] = useState(false);
  const [listOfStudents, setListOfStudents] = useState([]);
  const [validated, setValidated] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [WingId, setWingId] = useState(0);
  const [SessionId, setSessionId] = useState(
    localStorage.getItem("DefaultSession") || "0"
  );
  const [ClassId, setClassId] = useState(0);
  const [SectionID, setSectionID] = useState(0);
  const [GroupId, setGroupId] = useState(-1);
  const [ConcessionId, setConcessionId] = useState(0);
  const [BusRouteId, setBusRouteId] = useState(-1);
  const [Status_Type_Id, setStatusTypeId] = useState(0);
  const [Registration_No, setRegistrationNo] = useState("");
  const [StudentID, setStudentID] = useState(0);
  const [Keywords, setKeywords] = useState("");
  const [BayFormNo, setBayFormNo] = useState("");
  const [Gender, setGender] = useState("");
  const [Balance, setBalance] = useState("");
  const [BalanceType, setBalanceType] = useState("-1");
  const [DateOfBirth, setDateOfBirth] = useState("-1");
  const [OrderBy, setOrderBy] = useState("Student_Name");
  const [FamilyNo, setFamilyNo] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");

  const [notifTitle, setNotifTitle] = useState("");
  const [notifDetails, setNotifDetails] = useState("");

  const [pendingList, setPendingList] = useState([]);
  const [pendingTotal, setPendingTotal] = useState(0);
  const [pendingNotificationTotal, setPendingNotificationTotal] = useState(0);
  const [pendingPage, setPendingPage] = useState(1);
  const [pendingPageSize] = useState(15);
  const [loadingPending, setLoadingPending] = useState(false);
  const [selectedPendingIds, setSelectedPendingIds] = useState([]);
  const [expandedGroupKeys, setExpandedGroupKeys] = useState([]);

  const buildSearchPayload = () => ({
    AccessKey,
    UserID,
    MemberType,
    pageNo,
    pageSize,
    SessionID: SessionId,
    Wing_Id: parseInt(WingId, 10) || 0,
    Class_Id: parseInt(ClassId, 10) || 0,
    Section_Id: parseInt(SectionID, 10) || 0,
    Registration_No,
    Student_ID: parseInt(StudentID, 10) || 0,
    Keywords,
    Balance,
    BalanceType,
    BayFormNo,
    Gender,
    DateOfBirth,
    Concession_Rule_ID: ConcessionId,
    BusRouteID: BusRouteId,
    Status_Type_Id,
    Group_Id: GroupId,
    OrderBy,
    FamilyNo,
    StartDate,
    EndDate,
  });

  const executeStudentSearch = () => {
    setLoadingList(true);
    axios({
      method: "post",
      url: config.base_url + "Student/AdvanceSearch",
      headers: { "Content-Type": "application/json" },
      data: buildSearchPayload(),
    })
      .then((response) => {
        setListOfStudents(response.data.ListofRecords || []);
        setTotalRecords(response.data.totalRecords || 0);
      })
      .catch(() => {
        toast.error("Search failed.", { position: toast.POSITION.TOP_RIGHT });
      })
      .finally(() => {
        setLoadingList(false);
      });
  };

  useEffect(() => {
    document.title = "Student notifications";
  }, []);

  useEffect(() => {
    if (activeTab === "send") {
      executeStudentSearch();
    }
  }, [pageNo, pageSize, activeTab]);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (pageNo === 1) executeStudentSearch();
      else setPageNo(1);
    }
    setValidated(true);
  };

  const handlePageChange = (p) => {
    setPageNo(p);
  };

  const getSelectedStudentIds = () => {
    const inputs = document.querySelectorAll("input.notif-student-check");
    const ids = [];
    inputs.forEach((input) => {
      if (input.checked) {
        const v = parseInt(input.value, 10);
        if (v > 0) ids.push(v);
      }
    });
    return ids;
  };

  const handleSendNotifications = () => {
    const ids = getSelectedStudentIds();
    if (ids.length === 0) {
      toast.error("Select at least one student.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    const title = (notifTitle || "").trim();
    const details = (notifDetails || "").trim();
    if (!title || !details) {
      toast.error("Enter notification title and details.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const data = {
      AccessKey,
      UserID: parseInt(UserID, 10) || 0,
      MemberType,
      Notification_Title: title,
      Notification_Details: details,
      Student_ID_List: ids,
      Sender_Display_Name: fullName || localStorage.getItem("UserName") || "",
      Sender_Group_Name: groupName || MemberType || "",
    };

    axios({
      method: "post",
      url: config.base_url + "StudentNotification/AddPendingStudentNotifications",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setNotifTitle("");
          setNotifDetails("");
          document
            .querySelectorAll("input.notif-student-check")
            .forEach((el) => {
              el.checked = false;
            });
        } else {
          toast.error(response.data.status_message || "Failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const loadPending = () => {
    setLoadingPending(true);
    axios({
      method: "post",
      url: config.base_url + "StudentNotification/GetPendingStudentNotifications",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType,
        pageNo: pendingPage,
        pageSize: pendingPageSize,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setPendingList(res.data.ListofRecords || []);
          setPendingTotal(res.data.totalRecords || 0);
          setPendingNotificationTotal(res.data.totalNotifications || 0);
        } else {
          setPendingList([]);
          setPendingTotal(0);
          setPendingNotificationTotal(0);
        }
      })
      .catch(() => {
        toast.error("Could not load pending list.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setLoadingPending(false));
  };

  useEffect(() => {
    if (activeTab === "approve") {
      setExpandedGroupKeys([]);
      loadPending();
    }
  }, [activeTab, pendingPage]);

  const buildPendingGroupKey = (row) =>
    [
      row.Title,
      row.Details,
      row.Class_Name,
      row.Section_Name,
      row.Wing_Name,
      row.Sent_By,
      row.Sent_By_Type,
    ].join("||");

  const getGroupNotificationIds = (row) =>
    (row.Notification_IDs || []).map((id) => parseInt(id, 10)).filter((id) => id > 0);

  const getAllPageNotificationIds = () =>
    pendingList.flatMap((row) => getGroupNotificationIds(row));

  const isGroupFullySelected = (row) => {
    const ids = getGroupNotificationIds(row);
    return ids.length > 0 && ids.every((id) => selectedPendingIds.includes(id));
  };

  const isGroupPartiallySelected = (row) => {
    const ids = getGroupNotificationIds(row);
    const selectedCount = ids.filter((id) => selectedPendingIds.includes(id)).length;
    return selectedCount > 0 && selectedCount < ids.length;
  };

  const allPageIds = getAllPageNotificationIds();
  const allPageSelected =
    allPageIds.length > 0 && allPageIds.every((id) => selectedPendingIds.includes(id));
  const somePageSelected =
    allPageIds.some((id) => selectedPendingIds.includes(id)) && !allPageSelected;

  const toggleSelectAllOnPage = () => {
    if (allPageSelected) {
      setSelectedPendingIds((prev) =>
        prev.filter((id) => !allPageIds.includes(id))
      );
    } else {
      setSelectedPendingIds((prev) => [...new Set([...prev, ...allPageIds])]);
    }
  };

  const togglePendingGroup = (row) => {
    const ids = getGroupNotificationIds(row);
    if (ids.length === 0) return;

    if (isGroupFullySelected(row)) {
      setSelectedPendingIds((prev) => prev.filter((id) => !ids.includes(id)));
    } else {
      setSelectedPendingIds((prev) => [...new Set([...prev, ...ids])]);
    }
  };

  const toggleGroupExpanded = (groupKey) => {
    setExpandedGroupKeys((prev) =>
      prev.includes(groupKey)
        ? prev.filter((key) => key !== groupKey)
        : [...prev, groupKey]
    );
  };

  const handleApprove = () => {
    if (selectedPendingIds.length === 0) {
      toast.error("Select notification group(s) to approve.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    axios({
      method: "post",
      url: config.base_url + "StudentNotification/ApproveStudentNotifications",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType,
        Notification_ID_List: selectedPendingIds,
        Approver_Display_Name:
          fullName || localStorage.getItem("UserName") || "",
        Approver_Group_Name: groupName || MemberType || "",
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          const push = res.data.push_summary;
          const pushDetails = push?.push_details || [];
          const pushOk = push && push.SuccessCount > 0 && !push.FailureCount && !push.NotificationsWithNoTokens;

          toast.success(res.data.status_message || "Approved.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: pushOk ? 4000 : 12000,
          });

          if (push && !pushOk && pushDetails.length > 0) {
            toast.warn(
              <div>
                <strong>Firebase push details</strong>
                <ul style={{ margin: "8px 0 0", paddingLeft: "18px", textAlign: "left" }}>
                  {pushDetails.map((line, i) => (
                    <li key={i}>{line}</li>
                  ))}
                </ul>
              </div>,
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: false,
              }
            );
          } else if (push && push.SuccessCount > 0) {
            toast.info(
              `Firebase delivered to ${push.SuccessCount} device(s).`,
              { position: toast.POSITION.TOP_RIGHT }
            );
          }

          setSelectedPendingIds([]);
          setExpandedGroupKeys([]);
          loadPending();
        } else {
          toast.error(res.data.status_message || "Failed.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const renderStudentRows = () => {
    if (!listOfStudents || listOfStudents.length === 0) {
      return (
        <tr>
          <td colSpan="12" className="text-muted">
            No students found. Adjust filters and search.
          </td>
        </tr>
      );
    }
    return listOfStudents.map((item, index) => (
      <tr key={item.Student_ID || index}>
        <td>
          <input
            type="checkbox"
            className="form-check-input notif-student-check"
            value={item.Student_ID}
          />
        </td>
        <td>{item.Registration_No}</td>
        <td>
          {item.Student_Name}
          <br />
          <span className="text-muted small">{item.Father_Name}</span>
        </td>
        <td>{item.Father_CNIC}</td>
        <td>{item.FamilyNo}</td>
        <td>
          {item.Date_Of_Birth
            ? moment(item.Date_Of_Birth).format("DD/MM/YYYY")
            : ""}
        </td>
        <td>
          {item.Date_Of_Joining
            ? moment(item.Date_Of_Joining).format("DD/MM/YYYY")
            : ""}
        </td>
        <td>{item.Contact_Mobile}</td>
        <td>{item.SelectedClass?.SelectedWing?.Wing_Name}</td>
        <td>{item.SelectedClass?.Class_Name}</td>
        <td>{item.SelectedSection?.Section_Name}</td>
      </tr>
    ));
  };

  return (
    <>
      <StudentMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard" onClick={scrollToTop}>
                        Dashboard
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/students/StudentDashboard" onClick={scrollToTop}>
                        Students
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Student notifications
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Student notifications</div>
                <p className="text-muted small mb-0">
                  Send notifications to selected students (pending approval). A
                  second role approves them before they appear in the student
                  panel.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content mt-2">
          <div className="container">
            <Nav
              variant="tabs"
              className="mb-3"
              activeKey={activeTab}
              onSelect={(k) => {
                setActiveTab(k || "send");
                setSelectedPendingIds([]);
                setExpandedGroupKeys([]);
              }}
            >
              <Nav.Item>
                <Nav.Link eventKey="send">Send notifications</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="approve">Approve pending</Nav.Link>
              </Nav.Item>
            </Nav>

            {activeTab === "send" && (
              <>
                <div className="d-flex justify-content-end mb-2">
                  <button
                    type="button"
                    className="button button-white button-icon"
                    onClick={() => setShowFilters((s) => !s)}
                  >
                    {showFilters ? "Hide filters" : "Show filters"}
                    <i className="ri-filter-3-line ms-1"></i>
                  </button>
                </div>

                <div className={`collapse ${showFilters ? "show" : ""}`}>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSearchSubmit}
                  >
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="row gy-3 align-items-center">
                          <div className="col-md-3">
                            <label className="form-label">Session</label>
                            <select
                              className="form-select"
                              value={SessionId}
                              onChange={(e) => {
                                setSessionId(e.target.value);
                                setWingId(0);
                                setClassId(0);
                                setSectionID(0);
                              }}
                            >
                              <option value="0">---All---</option>
                              <SessionsDropDown selectedSession={SessionId} />
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Wing</label>
                            <select
                              className="form-select"
                              value={WingId}
                              onChange={(e) => {
                                setWingId(e.target.value);
                                setClassId(0);
                                setSectionID(0);
                              }}
                            >
                              <option value="0">---All---</option>
                              <WingsDropDown />
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Class</label>
                            <select
                              className="form-select"
                              value={ClassId}
                              onChange={(e) => {
                                setClassId(e.target.value);
                                setSectionID(0);
                              }}
                            >
                              <option value="0">Please Select</option>
                              {SessionId != 0 && WingId != 0 && (
                                <ClassesDropDown
                                  SessionID={SessionId}
                                  WingID={WingId}
                                />
                              )}
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Section</label>
                            <select
                              className="form-select"
                              value={SectionID}
                              onChange={(e) => setSectionID(e.target.value)}
                            >
                              <option value="0">Please Select</option>
                              {ClassId !== 0 && (
                                <SectionDropDown ClassID={ClassId} />
                              )}
                            </select>
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">Registration No</label>
                            <input
                              className="form-control"
                              value={Registration_No}
                              onChange={(e) => setRegistrationNo(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Student ID</label>
                            <input
                              type="number"
                              className="form-control"
                              value={StudentID || ""}
                              onChange={(e) =>
                                setStudentID(parseInt(e.target.value, 10) || 0)
                              }
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Keywords</label>
                            <input
                              className="form-control"
                              value={Keywords}
                              onChange={(e) => setKeywords(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Family No</label>
                            <input
                              className="form-control"
                              value={FamilyNo}
                              onChange={(e) => setFamilyNo(e.target.value)}
                            />
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">Student status</label>
                            <select
                              className="form-select"
                              value={Status_Type_Id}
                              onChange={(e) =>
                                setStatusTypeId(parseInt(e.target.value, 10) || 0)
                              }
                            >
                              <option value="0">---All---</option>
                              <StudentStatusDropDown />
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Group</label>
                            <select
                              className="form-select"
                              value={GroupId}
                              onChange={(e) =>
                                setGroupId(parseInt(e.target.value, 10) || 0)
                              }
                            >
                              <option value="-1">---All---</option>
                              <StudentGroupDropDown />
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Concession</label>
                            <select
                              className="form-select"
                              value={ConcessionId}
                              onChange={(e) =>
                                setConcessionId(parseInt(e.target.value, 10) || 0)
                              }
                            >
                              <option value="">---All---</option>
                              <ConcessionDropDown />
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Bus route</label>
                            <select
                              className="form-select"
                              value={BusRouteId}
                              onChange={(e) =>
                                setBusRouteId(parseInt(e.target.value, 10) || -1)
                              }
                            >
                              <option value="-1">--All--</option>
                              <option value="-2">All routes (transport)</option>
                              <BusrouteDropDown />
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Gender</label>
                            <select
                              className="form-select"
                              value={Gender}
                              onChange={(e) => setGender(e.target.value)}
                            >
                              <option value="">All</option>
                              <option value="1">Male</option>
                              <option value="0">Female</option>
                              <option value="Not Available">Not Available</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Balance</label>
                            <input
                              className="form-control"
                              value={Balance}
                              onChange={(e) => setBalance(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Balance type</label>
                            <select
                              className="form-select"
                              value={BalanceType}
                              onChange={(e) => setBalanceType(e.target.value)}
                            >
                              <option value="-1">All</option>
                              <option value="Debit">Debit</option>
                              <option value="Credit">Credit</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Date of birth</label>
                            <select
                              className="form-select"
                              value={DateOfBirth}
                              onChange={(e) => setDateOfBirth(e.target.value)}
                            >
                              <option value="-1">All</option>
                              <option value="Not Available">Not Available</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Bay form no.</label>
                            <input
                              className="form-control"
                              value={BayFormNo}
                              onChange={(e) => setBayFormNo(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Order by</label>
                            <select
                              className="form-select"
                              value={OrderBy}
                              onChange={(e) => setOrderBy(e.target.value)}
                            >
                              <option value="Student_Name">Student name</option>
                              <option value="Registration_No">Registration no</option>
                              <option value="Wing_Name">Wing name</option>
                              <option value="Class_Name">Class</option>
                              <option value="Student_ID">Student ID asc</option>
                              <option value="Student_ID desc">Student ID desc</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Entry from</label>
                            <input
                              type="date"
                              className="form-control"
                              value={StartDate}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Entry to</label>
                            <input
                              type="date"
                              className="form-control"
                              value={EndDate}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>

                          <div className="col-md-12 text-end">
                            <button
                              type="submit"
                              className="button button-primary mt-2"
                              disabled={loadingList}
                            >
                              {loadingList ? "Searching…" : "Search"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>

                <div className="card mb-3">
                  <div className="card-body">
                    <h6 className="mb-3">Notification content</h6>
                    <div className="mb-3">
                      <label className="form-label">Heading</label>
                      <input
                        className="form-control"
                        maxLength={500}
                        value={notifTitle}
                        onChange={(e) => setNotifTitle(e.target.value)}
                        placeholder="Short title"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Details</label>
                      <textarea
                        className="form-control"
                        rows={4}
                        maxLength={3000}
                        value={notifDetails}
                        onChange={(e) => setNotifDetails(e.target.value)}
                        placeholder="Full message"
                      />
                    </div>
                    <button
                      type="button"
                      className="button button-primary"
                      onClick={handleSendNotifications}
                    >
                      Send to selected students (pending approval)
                    </button>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body table-wrap">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="text-muted small">
                        Select students, then send. {totalRecords} match(es).
                      </span>
                    </div>
                    <table className="table table-theme">
                      <thead>
                        <tr>
                          <th style={{ width: 40 }}></th>
                          <th>Reg no</th>
                          <th>Name / Father</th>
                          <th>Father CNIC</th>
                          <th>Family</th>
                          <th>DOB</th>
                          <th>DOJ</th>
                          <th>Mobile</th>
                          <th>Wing</th>
                          <th>Class</th>
                          <th>Section</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loadingList ? (
                          <tr>
                            <td colSpan="11" className="text-center py-4">
                              <Spinner animation="border" size="sm" />
                            </td>
                          </tr>
                        ) : (
                          renderStudentRows()
                        )}
                      </tbody>
                    </table>
                    {totalRecords > 0 && (
                      <div className="pagination-wrap">
                        <div className="row gy-3 align-items-center">
                          <div className="col-md-2">
                            <label className="me-2">Page size</label>
                            <select
                              className="form-select d-inline-block"
                              style={{ width: "100px" }}
                              value={pageSize}
                              onChange={(e) => {
                                setPageNo(1);
                                setPageSize(parseInt(e.target.value, 10));
                              }}
                            >
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <Pagination
                            pageNo={pageNo}
                            pageSize={pageSize}
                            totalRecords={totalRecords}
                            onPageChange={handlePageChange}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            {activeTab === "approve" && (
              <div className="card">
                <div className="card-body">
                  <p className="text-muted small">
                    Approve notification groups to make them visible to students.
                    Pending: {pendingNotificationTotal} notification(s) in{" "}
                    {pendingTotal} group(s).
                  </p>
                  <div className="mb-3 d-flex flex-wrap align-items-center gap-2">
                    <button
                      type="button"
                      className="button button-primary"
                      onClick={handleApprove}
                      disabled={
                        loadingPending || selectedPendingIds.length === 0
                      }
                    >
                      Approve selected ({selectedPendingIds.length})
                    </button>
                    {selectedPendingIds.length > 0 && (
                      <button
                        type="button"
                        className="button button-white button-small"
                        onClick={() => setSelectedPendingIds([])}
                      >
                        Clear selection
                      </button>
                    )}
                  </div>
                  {loadingPending ? (
                    <Spinner animation="border" />
                  ) : pendingList.length === 0 ? (
                    <p className="text-muted mb-0">No pending notifications.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-theme table-sm">
                        <thead>
                          <tr>
                            <th style={{ width: 40 }}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                title="Select all groups on this page"
                                checked={allPageSelected}
                                ref={(el) => {
                                  if (el) el.indeterminate = somePageSelected;
                                }}
                                onChange={toggleSelectAllOnPage}
                              />
                            </th>
                            <th>Students</th>
                            <th>Title / details</th>
                            <th>Wing / class / section</th>
                            <th>Sent by</th>
                            <th>Created</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pendingList.map((row) => {
                            const groupKey = buildPendingGroupKey(row);
                            const isExpanded = expandedGroupKeys.includes(groupKey);
                            const studentNames = row.Student_Names || [];
                            return (
                              <React.Fragment key={groupKey}>
                                <tr>
                                  <td>
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={isGroupFullySelected(row)}
                                      ref={(el) => {
                                        if (el) {
                                          el.indeterminate =
                                            isGroupPartiallySelected(row);
                                        }
                                      }}
                                      onChange={() => togglePendingGroup(row)}
                                    />
                                  </td>
                                  <td className="text-nowrap">
                                    <button
                                      type="button"
                                      className="btn btn-link btn-sm p-0 text-decoration-none"
                                      onClick={() => toggleGroupExpanded(groupKey)}
                                      title={
                                        isExpanded
                                          ? "Hide students"
                                          : "Show students"
                                      }
                                    >
                                      <span className="badge bg-primary-subtle text-primary-emphasis">
                                        {row.Student_Count || studentNames.length}
                                      </span>
                                      <i
                                        className={`ri-arrow-${
                                          isExpanded ? "up" : "down"
                                        }-s-line ms-1`}
                                      ></i>
                                    </button>
                                  </td>
                                  <td>
                                    <div className="fw-semibold">{row.Title}</div>
                                    <div
                                      className="text-muted small"
                                      style={{ maxWidth: 360 }}
                                    >
                                      {row.Details}
                                    </div>
                                  </td>
                                  <td className="small">
                                    {row.Wing_Name || "—"} / {row.Class_Name || "—"}{" "}
                                    / {row.Section_Name || "—"}
                                  </td>
                                  <td className="small">
                                    {row.Sent_By}
                                    <br />
                                    <span className="text-muted">
                                      {row.Sent_By_Type}
                                    </span>
                                  </td>
                                  <td className="small text-nowrap">
                                    {row.Created_Date
                                      ? moment(row.Created_Date).format(
                                          "DD/MM/YYYY HH:mm"
                                        )
                                      : ""}
                                  </td>
                                </tr>
                                {isExpanded && (
                                  <tr className="table-light">
                                    <td></td>
                                    <td colSpan="5" className="small py-2">
                                      <strong>Students in this group:</strong>{" "}
                                      {studentNames.length > 0
                                        ? studentNames.join(", ")
                                        : "—"}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {pendingTotal > pendingPageSize && (
                    <div className="mt-2">
                      <span className="text-muted small me-2">
                        Page {pendingPage} of{" "}
                        {Math.ceil(pendingTotal / pendingPageSize)}
                      </span>
                      <button
                        type="button"
                        className="button button-white button-small me-2"
                        disabled={pendingPage <= 1}
                        onClick={() => setPendingPage((p) => Math.max(1, p - 1))}
                      >
                        Previous
                      </button>
                      <button
                        type="button"
                        className="button button-white button-small"
                        disabled={pendingPage * pendingPageSize >= pendingTotal}
                        onClick={() => setPendingPage((p) => p + 1)}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentNotifications;
